import * as userTokenRequests from "../../api/userTokenRequest";
import {START_LOAD, FINISH_LOAD} from "../reducers/racingBracket";
import {push} from "./message";


const startLoading = () => {
    return {type: START_LOAD};
};
const finishLoading = (racingBracket) => {
    return {type: FINISH_LOAD, payload: racingBracket};
};

export const getRacingBracket = () => {
    return dispatch => {
        dispatch(startLoading());
        userTokenRequests.getRacingBracket()
            .then(racingBracket => {
                dispatch(finishLoading(racingBracket))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};